module.exports = __webpack_public_path__ + "static/media/AfA-logo.813a83ae.svg";